export default "/images/7ca50a3e799de922d580c57608fcfbff.avif";